/**
 * DIN — Collapsible Row List: single-open accordion behavior.
 *
 * Opt-in via `data-din-single-open="true"` on any
 * `[data-section-type="collapsible-row-list"]` container.
 *
 * When a user clicks a closed item's trigger, any other open sibling
 * triggers in the same section are synthetically clicked first so the
 * theme's own handler closes them with its standard slide/ARIA logic.
 *
 * Capture phase ensures sibling-close clicks dispatch before the
 * theme's bubble-phase open handler runs for the newly clicked item.
 */
(function () {
  var TRIGGER_SELECTOR = '.collapsible-row-list-item__trigger';
  var SECTION_SELECTOR =
    '[data-section-type="collapsible-row-list"][data-din-single-open="true"]';

  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest && event.target.closest(TRIGGER_SELECTOR);
      if (!trigger) return;

      var section = trigger.closest(SECTION_SELECTOR);
      if (!section) return;

      // Trigger is already open → it will close on this click; leave siblings alone.
      if (trigger.getAttribute('aria-expanded') === 'true') return;

      var openSiblings = section.querySelectorAll(
        TRIGGER_SELECTOR + '[aria-expanded="true"]'
      );
      for (var i = 0; i < openSiblings.length; i++) {
        var other = openSiblings[i];
        if (other !== trigger) other.click();
      }
    },
    true
  );
})();
